/**
 * Indent / equipment request domain (UI mock).
 * Statuses: Pending → Recommended → Assigned (or Withdrawn).
 */

export const INDENT_STATUSES = [
  'Pending',
  'Recommended',
  'In progress',
  'Assigned',
  'Released',
  'Withdrawn',
];

export const INDENT_STATUS_OPTIONS = INDENT_STATUSES.map((s) => ({
  value: s,
  label: s,
}));

export const WORKING_HOURS_OPTIONS = ['8 Hrs', '12 Hrs', '24 Hrs'];

export const WORK_AREA_OPTIONS = ['Project', 'Operation'];

/** Unit of Measure — from Excel Indent / master lists. */
export const UOM_OPTIONS = ['MT', 'Ltr.', 'Cu. Mtr.', 'KG', 'Nos.', 'NIL', 'NA'];

export const UOM_SELECT_OPTIONS = UOM_OPTIONS.map((u) => ({
  value: u,
  label: u,
}));

export const indentSeed = [
  {
    indentId: 'IND-001',
    vendorId: 'VND-001',
    buId: 'BU-APMUL',
    siteId: 'ST-MSPVL',
    workArea: 'Project',
    raisedByName: 'Hitesh Chauhan',
    raisedByEmail: 'hitesh@mundraearth.example',
    createdAt: '2026-08-10T10:30:00',
    status: 'Recommended',
    notes: 'Need crane for building construction at site.',
    line: {
      lineId: 'IND-001-L1',
      equipmentType: 'Crane',
      specification: '15 Tn Pick & Carry Crane',
      quantity: 1,
      uom: 'Nos.',
      capacity: '15',
      capacityUom: 'T',
      requiredFrom: '2026-08-15',
      requiredTill: '2026-11-15',
      timePeriod: '3 Months',
      workingHours: '24 Hrs',
      remarks: 'With 2 operators. Required near MSPVL site.',
    },
    recommendations: [
      {
        recId: 'REC-001',
        assetId: 'AST-V002',
        recommendedAt: '2026-08-10T11:00:00',
        recommendedBy: 'Utkarsh Team',
        note: 'Nearby vendor crane · 15T · Available',
        status: 'Active',
      },
      {
        recId: 'REC-002',
        assetId: 'AST-V003',
        recommendedAt: '2026-08-10T11:00:00',
        recommendedBy: 'Utkarsh Team',
        note: 'Same agency second crane · 15T',
        status: 'Active',
      },
      {
        recId: 'REC-003',
        assetId: 'AST-006',
        recommendedAt: '2026-08-10T11:05:00',
        recommendedBy: 'Utkarsh Team',
        note: 'Villager SANY 25T · nearby Mundra belt',
        status: 'Active',
      },
    ],
    assignment: null,
  },
  {
    indentId: 'IND-002',
    vendorId: 'VND-001',
    buId: 'BU-APMUL',
    siteId: 'ST-MSPVL',
    workArea: 'Operation',
    raisedByName: 'Hitesh Chauhan',
    raisedByEmail: 'hitesh@mundraearth.example',
    createdAt: '2026-07-01T09:00:00',
    status: 'Assigned',
    notes: 'Backhoe for trench work.',
    line: {
      lineId: 'IND-002-L1',
      equipmentType: 'Backhoe Loader',
      specification: 'Backhoe loader JCB class',
      quantity: 1,
      uom: 'Nos.',
      capacity: '',
      capacityUom: '',
      requiredFrom: '2026-07-05',
      requiredTill: '2026-09-05',
      timePeriod: '2 Months',
      workingHours: '12 Hrs',
      remarks: 'Without diesel.',
    },
    recommendations: [
      {
        recId: 'REC-010',
        assetId: 'AST-004',
        recommendedAt: '2026-07-01T10:00:00',
        recommendedBy: 'Utkarsh Team',
        note: 'Verified villager JCB 3DX',
        status: 'Selected',
      },
    ],
    assignment: {
      assetId: 'AST-004',
      assignedAt: '2026-07-02T16:00:00',
      assignedBy: 'Vendor confirm',
      note: 'Work given to Suresh Laxman Gadhvi after offline discussion.',
    },
  },
  {
    indentId: 'IND-003',
    vendorId: 'VND-001',
    buId: 'BU-APMUL',
    siteId: 'ST-MSPVL',
    workArea: 'Project',
    raisedByName: 'Hitesh Chauhan',
    raisedByEmail: 'hitesh@mundraearth.example',
    createdAt: '2026-08-12T08:00:00',
    status: 'Pending',
    notes: '',
    line: {
      lineId: 'IND-003-L1',
      equipmentType: 'Excavator',
      specification: 'Excavator for foundation digging',
      quantity: 1,
      uom: 'Nos.',
      capacity: '1',
      capacityUom: 'CUM',
      requiredFrom: '2026-08-20',
      requiredTill: '2026-10-20',
      timePeriod: '2 Months',
      workingHours: '12 Hrs',
      remarks: 'Recommendation pending — use Find & recommend.',
    },
    recommendations: [],
    assignment: null,
  },
  {
    indentId: 'IND-004',
    vendorId: 'VND-002',
    buId: 'BU-MPL',
    siteId: 'ST-MPL-P1',
    workArea: 'Operation',
    raisedByName: 'Prakash Shah',
    raisedByEmail: 'ops@kutchhire.example',
    createdAt: '2026-08-11T14:20:00',
    status: 'Pending',
    notes: '',
    line: {
      lineId: 'IND-004-L1',
      equipmentType: 'Excavator',
      specification: 'Crawler excavator for earth work',
      quantity: 1,
      uom: 'Nos.',
      capacity: '1',
      capacityUom: 'CUM',
      requiredFrom: '2026-09-01',
      requiredTill: '2026-12-01',
      timePeriod: '3 Months',
      workingHours: '24 Hrs',
      remarks: 'No recommendations yet — open and use Find & recommend.',
    },
    recommendations: [],
    assignment: null,
  },
];
